import { render, staticRenderFns } from "./RegisterSeller.vue?vue&type=template&id=6afd6ad0&scoped=true"
import script from "./RegisterSeller.vue?vue&type=script&lang=js"
export * from "./RegisterSeller.vue?vue&type=script&lang=js"
import style0 from "./RegisterSeller.vue?vue&type=style&index=0&id=6afd6ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afd6ad0",
  null
  
)

export default component.exports